// extracted by mini-css-extract-plugin
export var closeButton = "_1x-3";
export var header = "_1x-0";
export var link = "_1x-1";
export var retryButton = "_1x-2";